/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { Log } from '../../core/logging/Log';
import { hideSpinnerAction, showSpinnerAction } from './spinner.actions';
import { HIDE_SPINNER, SHOW_SPINNER } from './spinner.types';

const initialState: {
    isSpinnerActive: boolean;
    spinnerMessage: string;
    errorCodes?: string;
} = {
    isSpinnerActive: false,
    spinnerMessage: '',
    errorCodes: '',
};

let spinnerTimeoutId: any = null;

const SpinnerReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SHOW_SPINNER:
        case HIDE_SPINNER:
            return {
                ...state,
                isSpinnerActive: payload.isSpinnerActive,
                spinnerMessage: payload.spinnerMessage,
                errorCodes: payload.errorCodes,
            };

        default:
            return state;
    }
};

export const showSpinner =
    (spinnerMessage: string, delay?: number, errorCodes?: string) =>
    (dispatch: Function, getState: Function) => {
        const { isSpinnerActive } = getState().spinner;
        if (delay) {
            if ((!isSpinnerActive || errorCodes) && spinnerTimeoutId === null) {
                spinnerTimeoutId = setTimeout(() => {
                    dispatch(showSpinnerAction(spinnerMessage, errorCodes));
                }, delay);
            }
        } else if (!isSpinnerActive || errorCodes) {
            dispatch(showSpinnerAction(spinnerMessage, errorCodes));
        }
    };

export const hideSpinner = () => (dispatch: Function, getState: Function) => {
    const { isSpinnerActive } = getState().spinner;
    clearTimeout(spinnerTimeoutId);
    spinnerTimeoutId = null;
    Log.i('Spinner Timeout cleared. {spinnerTimeoutId: ', spinnerTimeoutId, '}');
    Diagnostics.info('Spinner Timeout cleared. {spinnerTimeoutId: ', spinnerTimeoutId, '}');
    if (isSpinnerActive) dispatch(hideSpinnerAction());
};

export default SpinnerReducer;
